import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, forwardRef, ViewEncapsulation } from '@angular/core';
import { RouterModule } from '@angular/router';
import { DfCatalogUiModule } from '@df/catalog-ui/df-catalog-ui.module';
import { Category, ICategoryDataV2 } from '@df/catalog/category/category';
import { GtmTrackViewItemListDirective } from '@df/module-gtm/track/view-item-list/gtm-track-view-item-list.directive';
import { DfImageWrapperComponent } from '@df/module-image/df-image-wrapper.component';
import { DfImageDirective } from '@df/module-image/df-image.directive';
import { InfiniteScrollDirective } from '@df/module-infinite-scroll/infinite-scroll.directive';
import { GridModule } from '@df/ui/atomic/atom/grid/grid.module';
import { HrefComponent } from '@df/ui/common/href/href.component';
import { SizeClassDirective } from '@df/ui/common/size-class.directive';
import { TranslatePipe } from '@df/ui/translation/translate.pipe';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent } from '@icms/core/content';
import { CmsBlogPostComponent } from '../../../../../cms/blog/post/cms-blog-post.component';
import { CustomCursorComponent } from '../../../../../ui/display/custom-cursor/custom-cursor.component';
import { CategoryComponent } from '../../../category/category.component';
import { ProductComponent } from '../../../product/product.component';
import { LocalModelCarouselV2Component } from './../local-model-carousel-v2/local-model-carousel-v2.component';
import { getFields } from './../local-model-carousel-v2/local-model-carousel-v2.config';

@Component({
    selector: 'page-component-category-carousel-v2',
    templateUrl: './../local-model-carousel-v2/local-model-carousel-v2.html',
    styleUrl: './../local-model-carousel/local-model-carousel.scss',
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports: [
        CategoryComponent,
        CmsBlogPostComponent,
        CommonModule,
        CustomCursorComponent,
        DfCatalogUiModule,
        DfImageDirective,
        DfImageWrapperComponent,
        GtmTrackViewItemListDirective,
        GridModule,
        HrefComponent,
        ICmsClientModule,
        InfiniteScrollDirective,
        forwardRef(() => ProductComponent),
        RouterModule,
        SizeClassDirective,
        TranslatePipe
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
@ICmsComponent<PageComponentCategoryCarouselV2Component>({
    id: 'category-carousel-v2',
    name: 'Category Carousel (Variant 2)',
    image: 'assets/images/cms/category-carousel-v2.png',
    description: 'Editorial carousel',
    tags: ['Homepage', 'Landing', 'Blog', 'Inspiration', 'About us'],
    fields: getFields('category')
})
export class PageComponentCategoryCarouselV2Component extends LocalModelCarouselV2Component<Category<ICategoryDataV2>> {
    type = 'category';
}
